module.exports = require("./lib/_stream_writable.js")



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/writable.js
// module id = 134
// module chunks = 0